import {AppSettings} from "../../app-settings";
import {prop} from "../../decorators/property";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import {ISelectableSetting} from "../../settings/interfaces/selectable-setting";
import {JurisdictionCollection} from "../../settings/collections/jurisdictions";

@backboneModelProperties({
    urlRoot: AppSettings.ApiUrlPrefix + "search",
    relations : [{
        type: Backbone.Many,
        key: "Children",
        relatedModel: JurisdictionModel,
        collectionType: JurisdictionCollection
    }],
    defaults : {
        Selected: false,
        Children: []
    }

})
export class JurisdictionModel extends Backbone.AssociatedModel implements ISelectableSetting {
    /** Gets the RavenID for the jurisdiction */
    @prop() public Id: string;
    @prop() public JurisdictionId: number;
    @prop() public Children: Backbone.Collection<JurisdictionModel>;
    @prop() public Name: string;
    @prop() public HasChildren: boolean;
    @prop() public Partial: boolean;
    @prop() public Selected: boolean;

    public dataIdName = "jurisdiction";

    constructor(options?) {
        super(options);
    }

    public setupUIDrivenModelEventListeners() {
        this.listenTo(this, "change:Selected", this.selectedChange);
        this.listenTo(this.Children, "change:Selected", this.childChange);
        this.listenTo(this.Children, "change:Partial", this.childChange);
    }

    public toggleSelected() {
        this.Selected = !this.Selected;
    }

    public getChildById(id: string): JurisdictionModel {
        return this.Children.find((child) => child.JurisdictionId === parseInt(id));
    }

    public remove(): void {
        this.trigger("destroy", this);
    }

    private childChange(model: JurisdictionModel) {
        this.recalculateSelectedValueFromChildren();
        this.recalculatePartialValueFromChildren();
        this.trigger("childChanged", model);
    }

    private recalculateSelectedValueFromChildren() {
        const children = this.Children;
        let anyNotSelected = false;
        jQuery.each(children.models, (index, child) => {
            if (!child.Selected) {
                anyNotSelected = true;
                return false;
            }
        });

        this.stopListening(this, "change:Selected");
        this.Selected = !anyNotSelected;
        this.listenTo(this, "change:Selected", this.selectedChange);
    }

    private selectedChange(model: JurisdictionModel, val: boolean) {
        if (this.HasChildren) {
            this.stopListening(this.Children, "change:Selected");
            this.Children.each((child) => {
                child.Selected = val;
                this.trigger("childChanged", child);
            });
            this.listenTo(this.Children, "change:Selected", this.childChange);
            _.defer(() => {
                this.recalculatePartialValueFromChildren();
                this.recalculateSelectedValueFromChildren();
            });
        }
    }

    private recalculatePartialValueFromChildren() {
        const children = this.Children;
        const selectedChildren = children.filter((child) => (child.Selected)).length;
        const partialChildren = children.filter((child) => (child.Partial)).length;
        const someButNotAllSelected = (selectedChildren > 0) && (selectedChildren !== children.size());
        const anyPartial = partialChildren > 0;
        this.Partial = someButNotAllSelected || anyPartial;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/settings/models/jurisdiction.ts